export default __webpack_public_path__ + "static/media/emtyCardBk.0d683097.svg";